import { defineComponent as r, openBlock as a, createElementBlock as t, mergeProps as d, unref as V, renderSlot as m, createElementVNode as o, createCommentVNode as h } from "vue";
import { useScalarIcon as A } from "../hooks/useScalarIcon.js";
const i = { key: 0 }, p = { key: 1 }, u = { key: 2 }, M = { key: 3 }, g = { key: 4 }, v = { key: 5 }, f = {
  name: "ScalarIconSuitcase"
}, y = /* @__PURE__ */ r({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(n) {
    const l = n, { bind: Z, weight: e } = A(l);
    return (s, H) => (a(), t("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, V(Z)), [
      m(s.$slots, "default"),
      V(e) === "bold" ? (a(), t("g", i, H[0] || (H[0] = [
        o("path", { d: "M216,48H180V40a28,28,0,0,0-28-28H104A28,28,0,0,0,76,40v8H40A20,20,0,0,0,20,68V196a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V68A20,20,0,0,0,216,48ZM100,40a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4v8H100Zm56,32V192H100V72ZM44,72H76V192H44ZM212,192H180V72h32Z" }, null, -1)
      ]))) : V(e) === "duotone" ? (a(), t("g", p, H[1] || (H[1] = [
        o("path", {
          d: "M40,64H88V208H40a8,8,0,0,1-8-8V72A8,8,0,0,1,40,64Zm176,0H168V208h48a8,8,0,0,0,8-8V72A8,8,0,0,0,216,64Z",
          opacity: "0.2"
        }, null, -1),
        o("path", { d: "M216,56H176V48a24,24,0,0,0-24-24H104A24,24,0,0,0,80,48v8H40A16,16,0,0,0,24,72V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V72A16,16,0,0,0,216,56ZM96,48a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm64,24V200H96V72ZM40,72H80V200H40ZM216,200H176V72h40V200Z" }, null, -1)
      ]))) : V(e) === "fill" ? (a(), t("g", u, H[2] || (H[2] = [
        o("path", { d: "M216,56H176V48a24,24,0,0,0-24-24H104A24,24,0,0,0,80,48v8H40A16,16,0,0,0,24,72V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V72A16,16,0,0,0,216,56ZM96,72h64V200H96Zm0-24a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Z" }, null, -1)
      ]))) : V(e) === "light" ? (a(), t("g", M, H[3] || (H[3] = [
        o("path", { d: "M216,58H174V48a22,22,0,0,0-22-22H104A22,22,0,0,0,82,48V58H40A14,14,0,0,0,26,72V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V72A14,14,0,0,0,216,58ZM94,48a10,10,0,0,1,10-10h48a10,10,0,0,1,10,10V58H94Zm68,22V202H94V70ZM38,200V72a2,2,0,0,1,2-2H82V202H40A2,2,0,0,1,38,200Zm180,0a2,2,0,0,1-2,2H174V70h42a2,2,0,0,1,2,2Z" }, null, -1)
      ]))) : V(e) === "regular" ? (a(), t("g", g, H[4] || (H[4] = [
        o("path", { d: "M216,56H176V48a24,24,0,0,0-24-24H104A24,24,0,0,0,80,48v8H40A16,16,0,0,0,24,72V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V72A16,16,0,0,0,216,56ZM96,48a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm64,24V200H96V72ZM40,72H80V200H40ZM216,200H176V72h40V200Z" }, null, -1)
      ]))) : V(e) === "thin" ? (a(), t("g", v, H[5] || (H[5] = [
        o("path", { d: "M216,60H172V48a20,20,0,0,0-20-20H104A20,20,0,0,0,84,48V60H40A12,12,0,0,0,28,72V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V72A12,12,0,0,0,216,60ZM84,204H40a4,4,0,0,1-4-4V72a4,4,0,0,1,4-4H84Zm80,0H92V68h72Zm0-144H92V48a12,12,0,0,1,12-12h48a12,12,0,0,1,12,12Zm56,140a4,4,0,0,1-4,4H172V68h44a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  y as default
};
